import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import {
  and,
  collection,
  deleteDoc,
  doc,
  endBefore,
  getDocs,
  limit,
  limitToLast,
  or,
  orderBy,
  query,
  startAfter,
  Timestamp,
  where,updateDoc, arrayRemove
} from "firebase/firestore";
import AddButton from "components/buttons/addbutton";
import ListHeadingComponent from "components/headingComponent/listHeading";
import { dbFirestore } from "helper/config/firebase";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import Moment from "react-moment";
import CommonHeadings from "helper/constant/headings";
import Dateformat from "helper/constant/timeFormat";
import Constant from "helper/constant/constant";
import { Button } from "primereact/button";
import moment from "moment";
import * as XLSX from "xlsx";
import { Calendar } from "primereact/calendar";
import { ButtonGroup } from "react-bootstrap";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import WhatsAppConfig from "helper/config/whatsappConfig";

const StudentsList = () => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [studentsData, setStudentsData] = useState([]); // we fetch the data from the backend and shown in the form of list
  const [isLoading, setLoading] = useState(true);
  const [courseData, setCourseData] = useState([]);
  const [batchesData, setBatchesData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const navigate = useNavigate();

  //these are pagination variables
  const [page, setPage] = useState(0);
  const [isNext, setIsNext] = useState(false);
  const [filteredDates, setFilteredDates] = useState(null);
  const tabsData = [
    { id: 1, label: "Active" },
    { id: 2, label: "Leave" },
  ];

  const [activeTab, setActiveTab] = useState(tabsData[0].id);

  // Message modal state
  const [messageModalVisible, setMessageModalVisible] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [messageText, setMessageText] = useState("");
  const [isSendingMessage, setIsSendingMessage] = useState(false);

  // MARK: use Effect 
  useEffect(() => {
    fetchStudentsApi(activeTab);
    fetchCoursesApi();
    fetchBatchesApi();
    fetchPaymentDurationApi();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  useLayoutEffect(() => {
    document.title = CommonHeadings.studentListHeading
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // MARK: API
  async function fetchStudentsApi(id) {

    let q = query(
      collection(dbFirestore, TableName.students), where("status", "==", id === 1 ? "active" : "leave"),
      orderBy("admission_date_timestamp", "desc"),
      limit(Constant.perPage)
    );
    const querySnapshot = await getDocs(q);
    const array = querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }));
    setStudentsData(array);
    setLoading(false);
    setPage(0);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  }

  // course Api
  async function fetchCoursesApi() {
    let q = query(collection(dbFirestore, TableName.courses));

    const querySnapshot = await getDocs(q);

    setCourseData(
      querySnapshot.docs.map((docs) => ({
        ...docs.data(),
        firebase_id: docs.id,
      }))
    );
  }


  // fetch payment duration API
  async function fetchPaymentDurationApi() {
    let q = query(collection(dbFirestore, TableName.paymenyDuration));

    const querySnapshot = await getDocs(q);
    setPaymentData(
      querySnapshot.docs.map((docs) => ({
        ...docs.data(),
        firebase_id: docs.id,
      }))
    );
  }

  //  fetch batches API
  async function fetchBatchesApi() {
    let q = query(collection(dbFirestore, TableName.batches));

    const querySnapshot = await getDocs(q);
    setBatchesData(
      querySnapshot.docs.map((docs) => ({
        ...docs.data(),
        firebase_id: docs.id,
      }))
    );
  }

  //  Single record delete from multiple table
  async function deleteSingleStudentRecord(Students) {
    let pteStudentQuery = query(collection(dbFirestore, TableName.pteStudents), where("student_firebase_id", "==", Students.id));
    const pteStudentQuerySnapshot = await getDocs(pteStudentQuery);
    pteStudentQuerySnapshot.forEach((doc) => {
      deleteDoc(doc.ref);
    });

    let studentPerformanceQuery = query(collection(dbFirestore, TableName.studentPerformance), where("student_firebase_id", "==", Students.id));
    const studentPerfromancequerySnapshot = await getDocs(studentPerformanceQuery);
    studentPerfromancequerySnapshot.forEach((doc) => {
      deleteDoc(doc.ref);
    });

    let mockTestQuery = query(collection(dbFirestore, TableName.mockTest), where("student_firebase_id", "==", Students.id));
    const mockTestSnapshot = await getDocs(mockTestQuery);
    mockTestSnapshot.forEach((doc) => {
      deleteDoc(doc.ref);
    });

    let visaQuery = query(collection(dbFirestore, TableName.visa), where("student_firebase_id", "==", Students.id));
    const visaSnapshot = await getDocs(visaQuery);
    visaSnapshot.forEach((doc) => {
      deleteDoc(doc.ref);
    });

    let feeQuery = query(collection(dbFirestore, TableName.fee), where("student_id", "==", Students.id));
    const feeSnapshot = await getDocs(feeQuery);
    feeSnapshot.forEach((doc) => {
      deleteDoc(doc.ref);
    });

    let pendingFeeQuery = query(collection(dbFirestore, TableName.pendingFees), where("student_id", "==", Students.id));
    const pendingFeeSnapshot = await getDocs(pendingFeeQuery);
    pendingFeeSnapshot.forEach((doc) => {
      deleteDoc(doc.ref);
    });


    let attendanceQuery = query(
      collection(dbFirestore, TableName.attendance),
      where("attendance", "array-contains", Students.id)
    );
    
    const attendanceSnapshot = await getDocs(attendanceQuery);
    
    attendanceSnapshot.forEach(async (doc) => {
      await updateDoc(doc.ref, {
        attendance: arrayRemove(Students.id)
      });
    });
  }

  // delete API
  const deleteStudentsApi = async (Students) => {
    await deleteDoc(doc(dbFirestore, TableName.students, Students.id));

    deleteSingleStudentRecord(Students);

    setStudentsData((prevState) =>
      prevState.filter((el) => el.id !== Students.id)
    );
    toast.success(ToastMessages.demoStudentsDelete);
  };

  // serach api
  const searchStudentsApi = async (e) => {
    const searchText = e.target.value.toLowerCase();

    setGlobalFilterValue(searchText);

    if (searchText) {
      let q = query(
        collection(dbFirestore, TableName.students),
        or(
          and(
            where("name", ">=", searchText),
            where("name", "<=", searchText + "\uf8ff")
          ),
          and(
            where(
              "name",
              ">=",
              searchText.charAt(0).toUpperCase() + searchText.slice(1)
            ),
            where(
              "name",
              "<=",
              searchText.charAt(0).toUpperCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          ),
          and(
            where(
              "name",
              ">=",
              searchText.charAt(0).toLowerCase() + searchText.slice(1)
            ),
            where(
              "name",
              "<=",
              searchText.charAt(0).toLowerCase() +
              searchText.slice(1) +
              "\uf8ff"
            ),
            where("status", "==", activeTab === 1 ? "active" : "leave"),
          )
        )
      );
      const querySnapshot = await getDocs(q);

      setStudentsData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );
    } else {
      fetchStudentsApi(activeTab);
    }
  };


  // MARK: start loop to get data from the course list and compare id of course with the demo_category id
  const batchCategory = (studentModel) => {
    var courseObject = batchesData.find(function (batch) {
      return batch.firebase_id === studentModel.batch_firebase_id;
    });
    return `${courseObject?.batch_name}`;
  };

  // MARK: Actions
  const tapOnEdit = (StudentsData) => () => {
    navigate(RoutingPaths.editStudents, { state: StudentsData });
  };

  // student slip button
  const tapOnStudentsFeeSlip = (studentModal) => () => {
    navigate(RoutingPaths.downloadFeeSlip, { state: studentModal });
  };

  // view button
  const tapOnView = (studentModel) => () => {
    navigate(RoutingPaths.viewStudents, { state: studentModel });
  };

  // message button - open modal
  const tapOnMessage = (studentModel) => () => {
    setSelectedStudent(studentModel);
    setMessageText("");
    setMessageModalVisible(true);
  };

  // close message modal
  const hideMessageModal = () => {
    setMessageModalVisible(false);
    setSelectedStudent(null);
    setMessageText("");
  };

  // send WhatsApp message
  const sendWhatsAppMessage = async () => {
    if (!messageText.trim()) {
      toast.error("Please enter a message");
      return;
    }

    if (!selectedStudent?.contact_no) {
      toast.error("Student contact number not available");
      return;
    }

    setIsSendingMessage(true);

    try {
      // Format phone number (remove spaces, dashes, and ensure it has country code)
      let phoneNumber = selectedStudent.contact_no.replace(/[\s-]/g, "");
      if (!phoneNumber.startsWith("91")) {
        phoneNumber = "91" + phoneNumber;
      }

      const encodedMessage = encodeURIComponent(messageText);
      const url = `${WhatsAppConfig.baseUrl}?number=${phoneNumber}&type=text&message=${encodedMessage}&instance_id=${WhatsAppConfig.instanceId}&access_token=${WhatsAppConfig.accessToken}`;

      await fetch(url, { mode: "no-cors" });

      // With no-cors mode, we cannot read the response
      toast.success("Message sent successfully!");
      hideMessageModal();
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Please try again.");
    } finally {
      setIsSendingMessage(false);
    }
  };

  // delete confirmation message
  const tapOnDeleteConfirm = (StudentsData) => () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete this student data`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        deleteStudentsApi(StudentsData);
      }
    });
  };

  // filter function using in input
  const tapOnFilterButton = async () => {
    
    const querySnapshot = await createQueryForTable();
    const array = querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }));
    setStudentsData(array);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  async function createQueryForTable() {
    const filterText = filteredDates;

    if(!filterText) {
      toast.error(ToastMessages.filterDate);
      <ToastContainer /> 
    }
    
    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.students),
        where(
          "admission_date_timestamp",
          ">=",
          getFilteredDatesTimeStamp().startTime
        ),
        where(
          "admission_date_timestamp",
          "<=",
          getFilteredDatesTimeStamp().endTime
        ), where("status", "==", activeTab === 1 ? "active" : "leave"),
        orderBy("admission_date_timestamp", "desc"),
        limit(Constant.perPage)
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.students), where("status", "==", activeTab === 1 ? "active" : "leave"),
        orderBy("admission_date_timestamp", "desc"),
        limit(Constant.perPage)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }

  async function createQueryForExport() {
    const filterText = filteredDates;
    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.students),
        where(
          "admission_date_timestamp",
          ">=",
          getFilteredDatesTimeStamp().startTime
        ),
        where(
          "admission_date_timestamp",
          "<=",
          getFilteredDatesTimeStamp().endTime
        ), where("status", "==", activeTab === 1 ? "active" : "leave"),
        orderBy("admission_date_timestamp", "desc"),
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.students), where("status", "==", activeTab === 1 ? "active" : "leave"),
        orderBy("admission_date_timestamp", "desc")
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }


  // reset button function
  const tapOnResetButton = () => {
    setFilteredDates(null);
    fetchStudentsApi(activeTab);
  };

  // MARK:  function using in input
  const tapOnDateInput = (e) => {
    setFilteredDates(e.value);
  };

  //  for showing data in the list
  const nameAndAdmission = (student) => {
    return student.name + " - " + student.admission_no;
  };

  // MARK: filter dates
  function getFilteredDatesTimeStamp() {
    if (filteredDates) {
      const startDate = moment(filteredDates[0]).format(Dateformat.YYYYMMDD);
      const endDate = moment(filteredDates[1]).format(Dateformat.YYYYMMDD);

      const startTimestamp = Timestamp.fromDate(new Date(startDate)).toMillis();
      const endTimestamp = Timestamp.fromDate(new Date(endDate)).toMillis();
      return { startTime: startTimestamp, endTime: endTimestamp };
    }
    return null;
  }

  // MARK: pagination code
  const showNext = ({ item }) => {
    const fetchNextData = async () => {
      var paginationQuery;
      if (filteredDates) {
        paginationQuery = query(
          collection(dbFirestore, TableName.students),
          where(
            "admission_date_timestamp",
            ">=",
            getFilteredDatesTimeStamp().startTime
          ),
          where(
            "admission_date_timestamp",
            "<=",
            getFilteredDatesTimeStamp().endTime
          ), where("status", "==", activeTab === 1 ? "active" : "leave"),
          orderBy("admission_date_timestamp", "desc"),
          limit(Constant.perPage), startAfter(item.admission_date_timestamp)
        );
      } else {
        paginationQuery = query(
          collection(dbFirestore, TableName.students),
          where("status", "==", activeTab === 1 ? "active" : "leave"),
          orderBy("admission_date_timestamp", "desc"),
          limit(Constant.perPage),
          startAfter(item.admission_date_timestamp)
        );
      }
      const querySnapshot = await getDocs(paginationQuery);

      setStudentsData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );
      setPage(page + 1);
      setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
    };

    if (studentsData.length === 0) {
      alert(ToastMessages.alertMessage);
    } else {
      fetchNextData();
    }
  };

  //previous data function using pagination previous button
  const fetchPreviousData = async () => {
    var paginationQuery;

    if (filteredDates) {
      paginationQuery = query(
        collection(dbFirestore, TableName.students),
        where(
          "admission_date_timestamp",
          ">=",
          getFilteredDatesTimeStamp().startTime
        ),
        where(
          "admission_date_timestamp",
          "<=",
          getFilteredDatesTimeStamp().endTime
        ), where("status", "==", activeTab === 1 ? "active" : "leave"),
        orderBy("admission_date_timestamp", "desc"),
        limit(Constant.perPage), endBefore(studentsData[0].admission_date_timestamp),
        limitToLast(Constant.perPage)
      );
    } else {
      paginationQuery = query(
        collection(dbFirestore, TableName.students),
        where("status", "==", activeTab === 1 ? "active" : "leave"),
        orderBy("admission_date_timestamp", "desc"),
        endBefore(studentsData[0].admission_date_timestamp),
        limitToLast(Constant.perPage)
      );
    }


    const querySnapshot = await getDocs(paginationQuery);

    setStudentsData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    );
    setPage(page - 1);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  // condition while selecting the previous button
  const showPrevious = () => {
    if (studentsData.length === 0) {
      fetchStudentsApi(activeTab);
    } else {
      fetchPreviousData();
    }
  };

  // tabs are active
  const handleTabClick = async (id) => {
    setActiveTab(id);
    fetchStudentsApi(id)
  };


  //MARK: Search UI
  const searchBar = () => {
    return (
      <>
        <div className="tabs" style={{ marginBottom: "1rem" }}>
          {tabsData.map((tab) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => handleTabClick(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="search__main_div" style={{ justifyContent: "end" }}>

          <div className="me-2">
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search" />
              <InputText
                type="search"
                value={globalFilterValue}
                onChange={searchStudentsApi}
                placeholder="Search by name"
              />
            </IconField>
          </div>
          <div className="filter__button-section">
            <Calendar
              value={filteredDates}
              onChange={tapOnDateInput}
              selectionMode="range"
              readOnlyInput
              showIcon
              placeholder="Select start and end date"
            />

            <Button
              type="button"
              label="Filter"
              className="list__filter_button ms-2 me-2"
              onClick={tapOnFilterButton}
            />
            <Button
              type="button"
              label="Reset"
              className="list__reset_button"
              onClick={tapOnResetButton}
            />
          </div>
        </div>
      </>
    );
  };

  const header = searchBar();

  if (isLoading) {
    return <div className="loading-div"> Loading ... </div>;
  }

  const rejoinDate = (studentModel) => {
    if (studentModel.rejoin_date === "Invalid date") {
      return <Moment format={Dateformat.DDMMYYYY}>{studentModel.admission_date}</Moment>
    }

    if (studentModel.rejoin_date) {
      return <Moment format={Dateformat.DDMMYYYY}>{studentModel.rejoin_date}</Moment>
    } else {
      return <Moment format={Dateformat.DDMMYYYY}>{studentModel.admission_date}</Moment>
    }
  }
  // MARK: modify student model in which we add new inputs in an array

  function modifyStudentModel(doc) {
    const data = doc.data();
    var courseObject = courseData.find(function (course) {
      return course.id === data.selected_course_id;
    });
    var batchObject = batchesData.find(function (batch) {
      return batch.firebase_id === data.batch_firebase_id;
    });
    return {
      admission_no: data.admission_no,
      name: data.name,
      dob: data.dob,
      contact_no: data.contact_no,
      course: courseObject.name,
      batch_name: batchObject.batch_name,
      batch_fee: data.batch_fee,
      admission_date: data.admission_date,
      status: data.status,
      created_at: moment(data.created_at).format(
        Dateformat.YYYYMMDD
      ),

    };
  }

  // MARK: export data in the excel sheet
  const exportToExcel = () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to export these data.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.value) {
        const querySnapShot = await createQueryForExport();
        const mylist = querySnapShot.docs.map((model) => modifyStudentModel(model));
        const filterUserData = mylist.map(
          ({ admission_no, name, dob, contact_no, batch_fee, course, batch_name, admission_date, created_at, status }) => ({

            admission_no: admission_no,
            name: name,
            admission_date: admission_date,
            dob: dob,
            contact_no: contact_no,
            course: course,
            batch_name: batch_name,
            batch_fee: batch_fee,

            status: status,
            created_at: created_at,
          })
        );

        if (filteredDates) {
          const workBook = XLSX.utils.book_new();
          const workSheet = XLSX.utils.json_to_sheet(filterUserData);
          XLSX.utils.book_append_sheet(workBook, workSheet, "students");
          XLSX.writeFile(workBook, "regular_students.xlsx");
        } else {
          toast.error(ToastMessages.filterDate);
          <ToastContainer />
        }
      }
    });
  };

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <div className="modules__lists_main-content">
            <ListHeadingComponent
              classname="flex-grow-1"
              headingName={CommonHeadings.studentListHeading}
            />
            <Button
              label="Export Data"
              type="button"
              onClick={exportToExcel}
              className="list__export_button me-2"
            />
            <AddButton navigation={RoutingPaths.addStudents} />
          </div>

          <DataTable
            className="mt-5 mb-3"
            value={studentsData}
            header={header}
            emptyMessage="No data found."
          >
            <Column field="code" header="Name" className="table__column__capital" 
              body={(data) => nameAndAdmission(data)} ></Column>
            <Column field="admission_date" header="Admission Date" sortable body={rejoinDate}></Column>
            {/* <Column field="admission_date" header="Admission Date" sortable body=
              {(data) => (<Moment format={Dateformat.DDMMYYYY}>{data.admission_date}</Moment>)
              }></Column> */}
            <Column field="batch_fee" header="Batch Fee" body={priceBodyTemplate1}></Column>
            <Column field="batch_id" header="Batch Assign" className="table__column__capital"
              body={(data) => batchCategory(data)}></Column>
            <Column field="actions" header="Actions"
              body={(studentModel) =>
                <>
                  <div className="d-flex mt-3 text-start">
                    <Button
                      type="button"
                      className="lists__download_button"
                      onClick={tapOnStudentsFeeSlip(studentModel)}
                      tooltip="download"
                      tooltipOptions={{ position: "bottom" }}
                    >
                      <span className="pi pi-download"></span>
                    </Button>

                    <Button
                      type="button"
                      className="lists__edit_button"
                      onClick={tapOnEdit(studentModel)}
                      tooltip="edit"
                      tooltipOptions={{ position: "bottom" }}
                    >
                      <span className="pi pi-pencil"></span>
                    </Button>

                    <Button
                      type="button"
                      className="lists__edit_button"
                      onClick={tapOnView(studentModel)}
                      tooltip="view"
                      tooltipOptions={{ position: "bottom" }}
                    >
                      <span className="pi pi-eye"></span>
                    </Button>

                    <Button
                      type="button"
                      className="lists__edit_button"
                      onClick={tapOnMessage(studentModel)}
                      tooltip="message"
                      tooltipOptions={{ position: "bottom" }}
                    >
                      <span className="pi pi-comments"></span>
                    </Button>

                    <Button
                      severity="secondary"
                      type="button"
                      onClick={tapOnDeleteConfirm(studentModel)}
                      className="lists__delete_button"
                      tooltip="delete"
                      tooltipOptions={{ position: "bottom" }}
                    >
                      <span className="pi pi-trash"></span>{" "}
                    </Button>
                  </div>
                </>}></Column>

          </DataTable>
          <ButtonGroup
            style={{ gap: "1rem", alignSelf: "center" }}
            className="mt-5"
          >
            {
              <button
                disabled={page === 0 ? true : false}
                onClick={() => showPrevious()}
                className={
                  page === 0 ? "previous-disabled-button" : "previous-button"
                }
              >
                <span className="pi pi-angle-left">Previous</span>
              </button>
            }

            {
              <button
                disabled={isNext}
                onClick={() =>
                  showNext({ item: studentsData[studentsData.length - 1] })
                }
                className={
                  isNext ? "previous-disabled-button" : "previous-button"
                }
              >
                Next<span className="pi pi-angle-right"></span>
              </button>
            }
          </ButtonGroup>
        </div>
      </div>

      {/* WhatsApp Message Modal */}
      <Dialog
        header={`Send Message to ${selectedStudent?.name || "Student"}`}
        visible={messageModalVisible}
        style={{ width: "450px" }}
        onHide={hideMessageModal}
        footer={
          <div className="d-flex justify-content-end gap-2">
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={hideMessageModal}
              className="list__reset_button"
            />
            <Button
              label={isSendingMessage ? "Sending..." : "Send"}
              icon="pi pi-send"
              onClick={sendWhatsAppMessage}
              disabled={isSendingMessage}
              className="list__filter_button"
            />
          </div>
        }
      >
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="studentNumber" className="mb-2 d-block">
              <strong>Contact Number:</strong> {selectedStudent?.contact_no || "N/A"}
            </label>
          </div>
          <div className="field mt-3">
            <label htmlFor="message" className="mb-2 d-block">
              <strong>Message:</strong>
            </label>
            <InputTextarea
              id="message"
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              rows={5}
              placeholder="Type your message here..."
              autoResize
            />
          </div>
        </div>
      </Dialog>
      <ToastContainer />
    </div>
  );
};

const priceBodyTemplate1 = (student) => {
  return `Rs ${student.batch_fee_num?.toLocaleString()}`;
};


export default StudentsList;

